import { c as o } from "vendors/focus-trap.esm";
class c extends HTMLElement {
    constructor() {
        super(),
            (this.cartButton = document.getElementById("cart-button")),
            (this.notification = this),
            (this.sectionId = this.dataset.sectionId),
            (this.continueButton = this.querySelector(".cart-notification__continue")),
            (this.onBodyClick = this.handleBodyClick.bind(this)),
            (this.focusTrap = o(this.notification, { allowOutsideClick: !0 })),
            this.bindEvents();
    }
    bindEvents() {
        this.addEventListener("keyup", (t) => {
            t.code.toUpperCase() === "ESCAPE" && this.close();
        }),
            this.querySelectorAll('button[type="button"]').forEach((t) => {
                t.addEventListener("click", (i) => {
                    this.close();
                });
            });
    }
    open() {
        this.notification.classList.add("cart-notification--active"),
            this.notification.focus(),
            this.focusTrap.activate(),
            document.body.addEventListener("click", this.onBodyClick),
            this.querySelector(".cart-notification__continue").addEventListener("click", (t) => {
                t.preventDefault(), this.close();
            });
    }
    close() {
        this.notification.classList.remove("cart-notification--active"), document.body.removeEventListener("click", this.onBodyClick), this.focusTrap.deactivate(), this.activeElement.focus();
    }
    handleBodyClick(t) {
        const i = t.target;
        i !== this.notification && !i.closest("cart-notification") && this.close();
    }
    setActiveElement(t) {
        this.activeElement = t;
    }
    getSectionsToRender() {
        return [{ id: "cart-notification-product", selector: `#cart-notification-product-${this.productId}` }, { id: "cart-notification-links" }, { id: "cart-button" }, { id: "cart-icon-button" }];
    }
    renderContents(t) {
        (this.productId = t.id),
            this.getSectionsToRender().forEach((i) => {
                const e = document.querySelectorAll(`#${i.id}`);
                e.length &&
                    e.forEach((n) => {
                        n.innerHTML = this.getSectionInnerHTML(t.sections[i.id], i.selector);
                    });
            }),
            this.open();
    }
    getSectionInnerHTML(t, i = ".shopify-section") {
        return new DOMParser().parseFromString(t, "text/html").querySelector(i).innerHTML;
    }
}
customElements.define("cart-notification", c);
